(() => {
  const rootPath = (() => {
    const value = window.Shopify?.routes?.root || '/';
    return value.endsWith('/') ? value : `${value}/`;
  })();

  const restricted = {
    '58306376270198': { type: 'membership', route: 'pages/membership' },
    '58306376401270': { type: 'ticket', route: 'pages/eventanmalan' },
    '58306376434038': { type: 'ticket', route: 'pages/eventanmalan' }
  };

  const requiredProperties = {
    membership: ['För- och efternamn', 'E-post', 'Telefon', 'Födelsedatum', 'Ort', 'Medlemsfoto', 'Åldersintyg', 'Samtycke'],
    ticket: ['Förnamn', 'Efternamn', '_Personnummer', 'E-post för biljett', 'Mobilnummer', 'Uppgifterna bekräftade']
  };

  const text = (value) => {
    if (value instanceof File) return value.size > 0 ? value.name || 'file' : '';
    if (Array.isArray(value)) return value.map(text).join('').trim();
    return String(value ?? '').trim();
  };

  const routeFor = (id) => `${rootPath}${restricted[id].route}`;
  const redirect = (id) => window.location.assign(`${routeFor(id)}?obligatoriska_uppgifter=1`);

  const propertiesFromEntries = (entries) => {
    const result = {};
    let id = '';
    for (const [key, value] of entries) {
      if (key === 'id') id = text(value);
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match) result[match[1]] = value;
    }
    return [{ id, properties: result }];
  };

  const parseJsonPayload = (value) => {
    const payload = typeof value === 'string' ? JSON.parse(value) : value;
    const items = Array.isArray(payload?.items) ? payload.items : [payload];
    return items.map((item) => ({
      id: text(item?.id || item?.variant_id || item?.variantId),
      properties: item?.properties || {}
    }));
  };

  const parseBody = (body) => {
    if (!body) return [];
    if (body instanceof FormData || body instanceof URLSearchParams) return propertiesFromEntries(body.entries());
    if (typeof body === 'string') {
      try { return parseJsonPayload(body); } catch (_) {
        try { return propertiesFromEntries(new URLSearchParams(body).entries()); } catch (_) { return []; }
      }
    }
    if (typeof body === 'object') {
      try { return parseJsonPayload(body); } catch (_) { return []; }
    }
    return [];
  };

  const hasRequiredProperties = (id, properties = {}) => {
    const item = restricted[id];
    if (!item) return true;
    return requiredProperties[item.type].every((key) => text(properties[key]) !== '');
  };

  const formVariantId = (form) => {
    try { return text(new FormData(form).get('id')); } catch (_) {
      return text(form.querySelector('[name="id"]')?.value);
    }
  };

  const isApprovedForm = (form, id) => {
    if (id === '58306376270198') return Boolean(form.closest('[data-kuf-payment-root]'));
    return Boolean(form.matches('[data-kuf-ticket-form]'));
  };

  const blockUnapprovedForm = (form, event) => {
    if (!(form instanceof HTMLFormElement)) return false;
    const id = formVariantId(form);
    if (!restricted[id] || isApprovedForm(form, id)) return false;
    event?.preventDefault();
    event?.stopImmediatePropagation();
    redirect(id);
    return true;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const action = form instanceof HTMLFormElement ? form.action || '' : '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) blockUnapprovedForm(form, event);
  }, true);

  document.addEventListener('click', (event) => {
    const control = event.target.closest('button, input[type="submit"]');
    const form = control?.form;
    if (!form) return;
    const action = form.action || '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) blockUnapprovedForm(form, event);
  }, true);

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)) {
      const items = parseBody(init.body);
      const invalid = items.find((item) => restricted[item.id] && !hasRequiredProperties(item.id, item.properties));
      if (invalid) {
        redirect(invalid.id);
        throw new Error('Fyll i alla obligatoriska uppgifter innan produkten kan läggas i kundkorgen.');
      }
    }
    return originalFetch(input, init);
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this.__kufCartUrl = String(url || '');
    return xhrOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(this.__kufCartUrl || '')) {
      const items = parseBody(body);
      const invalid = items.find((item) => restricted[item.id] && !hasRequiredProperties(item.id, item.properties));
      if (invalid) {
        redirect(invalid.id);
        try { this.abort(); } catch (_) {}
        return;
      }
    }
    return xhrSend.call(this, body);
  };

  const removeInvalidExistingItems = async () => {
    if (/\/checkouts?\//.test(window.location.pathname)) return;
    try {
      const response = await originalFetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const updates = {};
      for (const item of cart.items || []) {
        const id = text(item.variant_id);
        if (restricted[id] && !hasRequiredProperties(id, item.properties || {})) updates[item.key] = 0;
      }
      if (!Object.keys(updates).length) return;
      const cleaned = await originalFetch(`${rootPath}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (cleaned.ok) window.location.reload();
    } catch (_) {}
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeInvalidExistingItems, { once: true });
  else removeInvalidExistingItems();
})();
